import { Injectable } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

const MONTH_YEAR_LABEL: Intl.DateTimeFormatOptions = {
  month: 'long',
  year: 'numeric',
};

/** Formatos del calendario de fecha de entrega: la fecha se muestra DD/MM/YYYY. */
export const DELIVERY_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel: MONTH_YEAR_LABEL,
    dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' },
    monthYearA11yLabel: MONTH_YEAR_LABEL,
  },
};

@Injectable()
export class DeliveryDateAdapter extends NativeDateAdapter {
  /** En el calendario de entrega la semana empieza en lunes. */
  override getFirstDayOfWeek(): number {
    return 1;
  }

  /** La cabecera del calendario muestra el mes en singular: "Julio 2026". */
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat !== MONTH_YEAR_LABEL) {
      return super.format(date, displayFormat);
    }

    const month = this.getMonthNames('long')[date.getMonth()];

    return `${month.charAt(0).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;
  }
}
